module.exports = __webpack_public_path__ + "static/media/vt_logo.8fd1311f.jpeg";